<template>
	<div v-if="isVisible()" class="h1-safety">
		<div class="container">
			<div class="h1-safety__copy">
				A message from our CEO (Johnny) regarding the H1 safety issue: <a href="https://blog.nzxt.com/a-message-from-our-ceo-johnny-regarding-the-h1-safety-issue/">nzxt.co/h1-safety-issue</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "H1SafetyFlashBanner",
	methods: {
		isVisible() {
			const includedRoutes = [
				"step2",
				"h1-mini-pc"
			];

			return includedRoutes.includes(this.$route.name);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.h1-safety {
	background-color: $purple;
	color: white;
	display: flex;
	align-items: center;
	padding: 15px 0;
	font-size: 18px;

	@media screen and (max-width: 670px) {
		font-size: 14px;
	}

	&__copy {
		text-align: center;
	}

	a {
		text-decoration: underline;
		font-weight: bold;
		color: #FFF;
	}

	a:hover {
		text-decoration: none;
	}
}
</style>
